import { render, staticRenderFns } from "./tournamentLeaderboard.vue?vue&type=template&id=38b8bb4c&"
import script from "./tournamentLeaderboard.vue?vue&type=script&lang=js&"
export * from "./tournamentLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./tournamentLeaderboard.vue?vue&type=style&index=0&id=38b8bb4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports